export interface AggregatePortfolioItem {
  name: string;
  total: number;
  currency: string;
}

export interface AssetClassPerformance {
  name: string;
  performance: number;
  benchmarkPerformance?: number;
}
export const defaultAssetClassPerformances: AssetClassPerformance[] = [
  { name: "Local Equity", performance: 0, benchmarkPerformance: 0 },
  { name: "International Equity", performance: 0, benchmarkPerformance: 0 },
  { name: "Local Fixed Income", performance: 0, benchmarkPerformance: 0 },
  {
    name: "International Fixed Income",
    performance: 0,
    benchmarkPerformance: 0,
  },
  {
    name: "Cash And Money Market",
    performance: 0,
    benchmarkPerformance: 0,
  },
  {
    name: "Alternative Investments",
    performance: 0,
    benchmarkPerformance: 0,
  },
];



// WEBPACK FOOTER //
// ./src/models/portfolio/aggregatePortfolioItem.ts